'use client';

import { c as _c } from "react/compiler-runtime";
import { Alert } from '@module/mdrt-org/shared/components/alert/alert';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { useSessionStorageState } from '@module/mdrt-org/shared/utils/hooks/use-session-storage-state';
import { AlertVariant } from '@shared/ui-components/alert/alertVariant';
import { LOGIN_ALERT_HAS_BEEN_CLOSED_BY_USER_KEY } from '@shared/utils/constants/session-storage-keys';
type LoginAlertProps = {
  className?: string;
  isSearchUpdated: boolean;
  message: string;
  totalResults: number;
};
export const LoginAlert = t0 => {
  const $ = _c(10);
  const {
    className,
    isSearchUpdated,
    message,
    totalResults
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValue: "false",
      key: LOGIN_ALERT_HAS_BEEN_CLOSED_BY_USER_KEY
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [sessionValue, setSessionValue] = useSessionStorageState(t1);
  const {
    status
  } = useUserContext();
  const showAlert = isSearchUpdated && status === "unauthenticated" && sessionValue !== "true" && totalResults > 0;
  let t2;
  if ($[1] !== setSessionValue) {
    t2 = () => {
      setSessionValue("true");
    };
    $[1] = setSessionValue;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleAlertClose = t2;
  let t3;
  if ($[3] !== className || $[4] !== handleAlertClose || $[5] !== message || $[6] !== showAlert) {
    t3 = showAlert && <Alert className={className} data-testid="search-alert-for-not-loged-users" message={message} onClose={handleAlertClose} variant={AlertVariant.Informational} />;
    $[3] = className;
    $[4] = handleAlertClose;
    $[5] = message;
    $[6] = showAlert;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <>{t3}</>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};